export const VARIANT_OPTIONS = [
  'solid',
  'outline',
  'faded',
  'link',
  // just a text
  'ghost',
  // ghost + outline
  'hollow',
];
export const COLOR_OPTIONS = [
  'blue',
  'ruby',
  'amber',
  'slate',
  'teal',
  'gapify',
];
export const SIZE_OPTIONS = ['xs', 'sm', 'md', 'lg', 'xl'];
export const JUSTIFY_OPTIONS = ['start', 'center', 'end'];

export const EXCLUDED_ATTRS = [
  'variant',
  'color',
  'size',
  'icon',
  'trailingIcon',
  'isLoading',
  ...VARIANT_OPTIONS,
  ...COLOR_OPTIONS,
  ...SIZE_OPTIONS,
  ...JUSTIFY_OPTIONS,
];
